import request from '@/config/axios'

export const getMessagePage = (params: any) => request.get({ url: '/rental/message/page', params })

export const createMessage = (data: {
  memberId?: number | string
  msgType?: string
  title: string
  content: string
  linkUrl?: string
}) => request.post({ url: '/rental/message/create', data })
